export default {
    //设置cookie
	set: function (name, value, opts){
		opts = opts || {}
		var expires = opts.expires
		var domain = opts.domain
		var path = opts.path || '/'
		var secure = opts.secure ? 'secure' : ''

		let cookie = name + '=' +  encodeURI(value) + ';'
		if( expires || expires === 0 ){
		    var s = new Date(expires)
            cookie += 'expires=' + s.toUTCString()  + ';'
            /*var oDate = new Date();
            var expiresTime = oDate.getTime() + expires
            // oDate.setDate( oDate.getTime() + expires );
            cookie += ' expires=' + expiresTime + ';';
            // cookie += ' expires=' + oDate.toUTCString() + ';';*/
		}

		if(domain)cookie += ' domain=' + domain + ';'
		if(path)cookie += ' path=' + path + ';'
		if(secure)cookie += ' secure;'
		return document.cookie = cookie
	},
    //获取cookie
	get: function (name){
		var result = '', reg = new RegExp('(^|; )' + name + '=([^;]*)(;|$)');
		if( result = document.cookie.match(reg) ){
			return decodeURI( result[2] );
		}else{
			return '';
		}
	},
    //移除cookie
	remove: function (name){
        this.set(name, '', {expires: -1});
	}

};



// WEBPACK FOOTER //
// ./src/assets/js/cookie.js